import React from 'react';
import { useSelector } from 'react-redux';
import { ListFieldSection } from 'Components/Layout';
import { Field, TextOutput } from 'Components/Core';
import { WorksheetsResultsMessagesSection } from 'Components/Worksheets/Core';
import { withInjectedProps } from 'Components/Core/InjectedPropsContext';
import { createWashingSieveSizeSelector } from '../../../helpers';
import { IWorksheetComponent } from 'Components/Worksheets/Core/types';
import { pipe } from 'Lib/Hooks/Selectors';

const ResultsSectionContentBase = ({ createWorksheetSelector }: IWorksheetComponent) => {
  const washingSieveSizeCaption = useSelector(
    pipe(createWashingSieveSizeSelector(createWorksheetSelector!), (s) => s?.Caption ?? 'No. 200')
  );

  return (
    <Field
      label={`Passing ${washingSieveSizeCaption} (%)`}
      input={<TextOutput />}
      name="Results.PercentPassingWashingSieve"
    />
  );
};

const ResultsSectionContent = withInjectedProps(ResultsSectionContentBase);

const ResultsSectionBase = () => (
  <>
    <WorksheetsResultsMessagesSection />
    <ListFieldSection>
      <ResultsSectionContent />
    </ListFieldSection>
  </>
);

const ResultsSection = withInjectedProps(ResultsSectionBase);

export { ResultsSection, ResultsSectionContent };
